import styled from 'styled-components/macro';

const Header = styled(({className, children}) => (
    <header className={className}>
        {children}
    </header>
))`
  margin-bottom: 12px;
  @media only screen and (max-width: 780px) {
    margin-bottom: 0;
    padding-top: 50px;
  }
`;

export default Header;
